<script setup lang="ts">
import TrackListExportWatcher from '@/components/TrackListExportWatcher.vue';
import { useTrackListExportStore } from '@/stores/trackListExportStore';

/**
 * Keeps every in-flight track-list export watched, from anywhere in the app.
 *
 * Mounted in `App.vue` OUTSIDE `<RouterView>`, which is the whole point: an
 * export is started from an inspector, but the user is expected to close it and
 * carry on working, and the "ready" toast still has to reach them. Anything
 * mounted inside the router view would unmount on navigation and take its Echo
 * subscription with it.
 */
const trackListExportStore = useTrackListExportStore();

// Synchronous in setup, NOT in onMounted: children mount before their parent's
// onMounted runs, so pruning there would still have spun up a watcher for a
// stale entry — which would then poll for an operation row that no longer
// exists. A reload rehydrates the persisted list, so this is the real path.
trackListExportStore.pruneExpired();
</script>

<template>
  <TrackListExportWatcher
    v-for="inFlightExport in trackListExportStore.inFlightExports"
    :key="inFlightExport.operationId"
    :operation-id="inFlightExport.operationId"
    :scope="inFlightExport.scope"
    :label="inFlightExport.label"
  />
</template>
